export default __webpack_public_path__ + "static/media/rayia-soderberg-ev_GpmUPOwo-unsplash.d15671e6.jpg";